












































































































































































































































































import IconBase from "@/common/components/atoms/IconBase.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconHumanWithOutline from "@/common/components/icons/IconHumanWithOutline.vue";
import IconBarGraph from "@/common/components/icons/IconBarGraph.vue";
import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import IconThanksMessage from "@/common/components/icons/IconThanksMessage.vue";
import IconLogout from "@/common/components/icons/IconLogout.vue";
import IconNotification from "@/common/components/icons/IconNotification.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconOrderHistory from "@/common/components/icons/IconOrderHistory.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import IconFaqBalloon from "@/common/components/icons/IconFaqBalloon.vue";
import IconMypage from "@/common/components/icons/IconMypage.vue";
import TextLabelNewArrivalCount from "@/common/components/atoms/TextLabelNewArrivalCount.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import modalState from "@/common/store/modules/modalState";

import { karteLogin } from "@/common/assets/js/karte/";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";

import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Component({
  name: "TheHeaderUserNavi",
  components: {
    IconBase,
    IconUserImage,
    IconHumanWithOutline,
    IconLogout,
    IconThanksMessage,
    IconNotification,
    IconHeart,
    IconOrderHistory,
    IconHistoryLog,
    IconMail,
    IconFaqBalloon,
    TextLabelNewArrivalCount,
    IconBarGraph,
    IconPointDefault,
    IconMypage
  }
})
export default class TheHeaderUserNavi extends Vue {
  @Prop({ type: [String, Number], required: true, default: 0 })
  totalUnreadCount!: string | number;
  @Prop({ type: Number, required: true, default: 0 })
  thanksPointUnreadCount!: number;
  @Prop({ type: Number, required: true, default: 0 })
  whatsNewUnreadCount!: number;
  @Prop({ type: String, required: true, default: "" })
  userImage!: string;
  @Prop({ type: Boolean })
  closeHelpPoup!: boolean;

  profileNavi = {
    shown: false
  };

  userInfo = commons.userInfo;

  get closeModalState() {
    return modalState.closeModalState;
  }

  @Watch("closeModalState")
  onCloseModalState() {
    this.profileNavi.shown = false;
  }

  switchShownState() {
    this.$emit("update:close-help-popup", true);
    const shown = this.profileNavi.shown;
    this.profileNavi.shown = !shown;
  }

  get totalUnread() {
    return this.totalUnreadCount >= 10 ? "..." : this.totalUnreadCount;
  }

  get thanksPointUnread() {
    const total = this.thanksPointUnreadCount;
    return total >= 10 ? "..." : total;
  }

  get whatsNewUnread() {
    const total = this.whatsNewUnreadCount;
    return total >= 10 ? "..." : total;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get isAdmin() {
    return false;
  }

  get urls() {
    return {
      whatsNew: CONST_DATA.SITE_MAP.WHATS_NEW,
      favorites: process.env.VUE_APP_MYPAGE + '/favorites/',
      orders: process.env.VUE_APP_MYPAGE + '/orders',
      visit: process.env.VUE_APP_MYPAGE + '/visits/',
      pointConfirmation: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
      thanksPoint: CONST_DATA.SITE_MAP.THANKS_POINT,
      mailSettings: CONST_DATA.SITE_MAP.MAIL_DELIVERY_SETTINGS,
      qa: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/memberfaqic/index.html",
      faq: process.env.VUE_APP_BS_DOMAIN + "/contents/cgi/incentive/faq3/",
      mypage: process.env.VUE_APP_MYPAGE
    };
  }

  get showMailSettings() {
    return (
      !auth.user.approval_result_notification_mail &&
      !auth.user.point_expiry_notification_enabled &&
      !auth.user.point_balance_notification_enabled &&
      !auth.user.point_receipt_notification_enabled &&
      !auth.user.mail_magazine_enabled
    );
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async logout() {
    karteLogin(false);

    await fetch(commons.LOGOUT_URL, { method: "POST" })
      .then(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        window.location.href = "/logout";
      })
      .catch(() => {
        window.sessionStorage.clear();
        // window.localStorage.clear();
        LocalStorage.removeAll();
        window.location.href = "/logout";
      });
  }
}
